import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import "react-datepicker/dist/react-datepicker.css";
import { fi } from 'date-fns/locale/fi';
import { enUS } from 'date-fns/locale/en-US';
import { registerLocale } from "react-datepicker";
import DatePicker from 'react-datepicker';
import i18next from "i18next";

const DateInput = ({ label, name, value, onChange, min, max, error }: { label: string, name: string, value: string, onChange: (e: React.ChangeEvent<HTMLInputElement>) => void, min: string, max: string, error: string }) => {

  const dateString = value ?? '';
  const [day, month, year] = dateString.split('.');
  const parsedDate = dayjs(new Date(parseInt(year), parseInt(month) - 1, parseInt(day)));

  const selected = dateString !== '' ? parsedDate.toDate() : undefined;
  const minDate = dayjs(min).toDate();
  const maxDate = dayjs(max).toDate();

  const handleChange = (date: Date) => {
    const stringValue = date != null ? dayjs(date).format('DD.MM.YYYY') : undefined;
    const data = { target: { name, value: stringValue, type: 'date' } } as React.ChangeEvent<HTMLInputElement>;
    onChange(data);
  }

  useEffect(() => {
    const lang = i18next.language
    registerLocale(lang, lang === 'fi' ? fi : enUS);
  }, [i18next.language]);

  return (
    <label>
      {label}
      <div className="custom-date-picker">
        <DatePicker
          selected={selected}
          className={error ? 'invalid' : ''}
          onChange={handleChange}
          shouldCloseOnSelect={true}
          dateFormat="dd.MM.yyyy"
          minDate={minDate}
          maxDate={maxDate}
          popperPlacement="bottom-start"
          locale={i18next.language} />
      </div>
      {error && <span className="invalid">{error}</span>}
    </label>
  )
}

export default DateInput;
